import { mergeClasses } from '@blank/utilities'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useMemo } from 'react'
import { FieldError } from 'react-hook-form'
import { IconCheck } from '../../_icons/icons'

interface Props {
  fieldError?: FieldError
  isDirty?: boolean
  classNames?: string
}

const rules = [
  'minLength',
  'atLeastOneDigit',
  'atLeastOneUppercase',
  'atLeastOneLowercase',
  'atLeastOneSpecialCharacter',
] as const

export const PasswordHelper = ({ classNames, fieldError, isDirty }: Props) => {
  const { t } = useTranslation(['common-components'])

  const invalidRules = useMemo(() => {
    const errorTypes = fieldError?.types ? Object.keys(fieldError?.types) : []
    const isEmpty = errorTypes.includes('required')

    return rules.filter((rule) => {
      const ruleIsValid = isDirty && !isEmpty && !errorTypes.includes(rule)
      return !ruleIsValid
    })
  }, [isDirty, fieldError])

  if (invalidRules.length === 0) {
    return (
      <p
        className="flex items-center gap-2 text-success"
        data-testid="password-helper"
      >
        <IconCheck />
        {t('passwordHelper.secured')}
      </p>
    )
  }

  return (
    <div className={classNames} data-testid="password-helper">
      <p className="text-info-400">{t('passwordHelper.mustContain')}</p>
      <div className="flex flex-wrap">
        {invalidRules.map((rule, index) => {
          return (
            <div key={rule} className="flex">
              <p
                className={mergeClasses('flex items-center text-info-800', {
                  'text-danger': isDirty,
                })}
              >
                {t(`passwordHelper.rules.${rule}`)}
              </p>
              {index < invalidRules.length - 1 && (
                <span className="px-2 text-info-400">|</span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
